import { gql } from '@apollo/client';
import { ReportSectionState } from '@mnd-frontend/graphql-schema';
import { GREY_900 } from '@mnd-frontend/ui/shared/tokens';
import type { Report2PerceptionSentimentOverviewFragment } from '../../../../../generated/types';
import { SentimentOverviewGraph } from '../../charts';
import { Section, SectionHeader } from '../../common';

export const REPORT2_PERCEPTION_SENTIMENT_OVERVIEW_FRAGMENT = gql`
  fragment Report2PerceptionSentimentOverview on ReportPerceptionSentimentOverview {
    id
    title
    state
    perceptionSentimentMetrics: metrics {
      positiveSentimentPercent
      negativeSentimentPercent
      neutralSentimentPercent
      netSentimentScore
    }
  }
`;

const PerceptionSentimentOverview = ({
  section,
}: {
  section: Report2PerceptionSentimentOverviewFragment;
}) => {
  const { perceptionSentimentMetrics } = section;
  return (
    <Section>
      <SectionHeader
        color={GREY_900}
        as="h3"
        variant="reportHeadlineLarge"
        section={section}
        isSubsection
      />
      <SentimentOverviewGraph
        loading={section.state !== ReportSectionState.Done}
        positive={perceptionSentimentMetrics.positiveSentimentPercent}
        negative={perceptionSentimentMetrics.negativeSentimentPercent}
        neutral={perceptionSentimentMetrics.neutralSentimentPercent}
      />
    </Section>
  );
};

export default PerceptionSentimentOverview;
